import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import BrandLogo from "../components/BrandLogo";
import { exchangeWorkspaceAccess, saveBuyerSession } from "../lib/api";

export default function WorkspaceAccess() {
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) {
      setError("Invalid access link.");
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const data = await exchangeWorkspaceAccess(token);
        if (cancelled) return;
        saveBuyerSession(data);
        const base = (process.env.REACT_APP_WORKSPACE_URL || window.location.origin).replace(/\/$/, "");
        const path = data.redirect_path || `/workspace?buyer_id=${data.buyer_id}&workspace_id=${data.workspace_id}`;
        window.location.replace(`${base}${path}`);
      } catch (err) {
        if (!cancelled) {
          setError(err?.response?.data?.detail || "Could not sign you in. The link may have expired.");
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-screen wizard-surface flex flex-col items-center justify-center px-6">
      <BrandLogo to="/" variant="default" className="mb-10" />
      {error ? (
        <div className="max-w-md text-center">
          <p className="text-lg text-[hsl(var(--brand-navy))] font-medium">{error}</p>
          <p className="mt-3 text-sm text-neutral-500">
            Open your RFQ confirmation email or contact DeMaxtore support.
          </p>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-3 text-neutral-600">
          <Loader2 className="w-8 h-8 animate-spin text-[hsl(var(--brand-navy))]" />
          <p className="text-sm">Opening your workspace…</p>
        </div>
      )}
    </div>
  );
}
